import { render, staticRenderFns } from "./zEmpty.vue?vue&type=template&id=9fbc435e&scoped=true"
var script = {}
import style0 from "./zEmpty.vue?vue&type=style&index=0&id=9fbc435e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbc435e",
  null
  
)

export default component.exports